<template>
  <div>
      <el-dialog
          title="Refund Record"
          :visible.sync="dialogVisible"
          width="650px"
          :before-close="beforeClose">
          <div>
              <div v-for="item in refundRecord" :key="item.AM5115465165416513">
                  <div class="f" style="margin-bottom: 8px;font-size: 14px;color: #747A87;">
                      <p style="flex: 1">Rufund ID: {{ item.refundId }}</p>
                      <p style="flex: 1">Rufund Time: {{ getDayjs(item.refundDate).format('YYYY-MM-DD HH:mm:ss') }}</p>
                  </div>
                  <div style="margin-bottom: 20px;font-size: 14px;color: #747A87;">
                      <p>Refund Amount: {{ item.refundAmount }}</p>
                  </div>
                  <el-timeline>
                  <el-timeline-item
                      v-for="(timeItem, index) in item.refunds"
                      :key="index"
                      :type="timeItem.status | typeFilter"
                      :timestamp="getDayjs(timeItem.createDate).format('MMM-DD HH:mm:ss A')">
                      <span :style="{color: timeItem.status === 2 ? '#EB5757' : '#333'}">{{ showText(timeItem, item) || 'Refund Application'}}</span>
                      </el-timeline-item>
                  </el-timeline>
              </div>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import moment from 'moment'

export default {
data() {
  return {
    dialogVisible: false,
    refundRecord: []
  }
},
computed: {
  getDayjs() {
    return moment
  }
},
filters: {
  typeFilter(value) {
    let type = ''
    if (+value === 0) type = undefined
    if (+value === 1) type = 'primary'
    if (+value === 2) type = 'danger'
    return type
  }
},
methods: {
  handleClose() {},
  show(kkOrderId) {
    this.dialogVisible = true
    API.getOrderRefundRecord(kkOrderId).then((res) => {
      this.refundRecord = res.data
    })
  },
  showText(timeItem, item) {
    if (+timeItem.status === 0) return 'Refund Application'
    if (+timeItem.status === 1) return `Refunded Refund Amount $${item.refundAmount}`
    if (+timeItem.status === 2) return `Refund Failed  ${timeItem.refundFailReason}`
  },
  beforeClose() {
    this.dialogVisible = false
  }
}
}
</script>
